import { createElement } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import utils from '../utils';
import { jsxs as _jsxs } from "react/jsx-runtime";

var MonthDash = function MonthDash(props) {
  var x = props.x,
      label = props.label,
      vertical = props.vertical,
      secondary = props.secondary;
  var classes = classnames('ptr-timeline-month', {
    secondary: secondary
  });
  return /*#__PURE__*/_jsxs("g", {
    className: classes,
    children: [/*#__PURE__*/createElement(utils.dash.D1, {
      x: x,
      vertical: vertical
    }), label]
  });
};

MonthDash.propTypes = {
  x: PropTypes.number,
  label: PropTypes.element,
  vertical: PropTypes.bool,
  secondary: PropTypes.bool
};
MonthDash.defaultProps = {
  vertical: false,
  label: null
};
export default MonthDash;